import React from 'react';
import { IconLocalShipping } from '@tvg/fuse/icon/all';
import { IconElement } from '@tvg/fuse/icon-element';
import { Typography } from '@tvg/fuse/typography';
import { Link } from '@tvg/fuse/link';
import { Divider } from '@tvg/fuse/divider';
import { DeliveryCardProps } from '../DeliveryAndReturnsProps';
import styles from './DeliveryCard.module.css';

const CLICK_AND_COLLECT = 'FREE Delivery Options';

function DeliveryCard(props: DeliveryCardProps) {
  const { onClick, link, text, title } = props;

  return (
    <div className={styles.container} data-testid="delivery-card">
      <div className={styles.headingContainer}>
        <div className={styles.iconContainer}>
          <IconElement
            icon={title === CLICK_AND_COLLECT ? <IconLocalShipping /> : <IconLocalShipping />}
            responsiveSize="small"
            dataTestId="delivery-card-icon"
            srLabel="Delivery"
          />
        </div>
        <Typography tag="h2" type="heading" size="1" data-testid="delivery-card-title">
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </Typography>
      </div>
      <div
        className={[styles.textContainer, link ? styles.textContainerWithLink : styles.textContainerNoLink].join(' ')}
      >
        <Typography tag="p" type="paragraph" size="m1" data-testid="delivery-card-text">
          <span dangerouslySetInnerHTML={{ __html: text }} />
        </Typography>

        {link && (
          <Link
            href="#"
            onClick={(event: React.MouseEvent) => {
              event.preventDefault();
              onClick();
            }}
            data-testid="delivery-card-link"
            size="medium"
          >
            <span dangerouslySetInnerHTML={{ __html: link }} />
          </Link>
        )}
      </div>
      <div className={styles.dividerContainer}>
        <Divider />
      </div>
    </div>
  );
}

export default DeliveryCard;
